import { MapPin, Phone, MessageCircle, Camera, PartyPopper, Flame } from "lucide-react";
import { Button } from "../ui/button";
import { BRAND, WA_LINK } from "../../lib/constants";
import { CENTRE_ADDRESS, CENTRE_PHONE } from "./ResultCard";

export const LAUNCH_MESSAGE =
  "As a part of our website launch, you are eligible for a 50% discount. Seats are filling up soon — this discount is available for the first 100 students only.";

const waMessage = (r) =>
  `Hi TASSEI, I registered for the Website Launch Offer.\n` +
  `Name: ${r.name}\nClaim ID: ${r.claim_id}\nDiscount: ${r.discount}% (Launch Offer)\n\n` +
  `I would like to confirm my seat and claim this discount. Please guide me.`;

const Stat = ({ label, value, testId, accent }) => (
  <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4">
    <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#64748B]">{label}</div>
    <div data-testid={testId} className={`mt-1 font-heading text-xl font-extrabold ${accent || "text-[#0A192F]"}`}>{value}</div>
  </div>
);

export const LaunchResultCard = ({ result: r }) => (
  <div data-testid="launch-result" className="bg-white border border-slate-200 rounded-3xl p-7 md:p-9 shadow-xl shadow-slate-200/50">
    {r.existing && (
      <div data-testid="launch-existing-notice" className="mb-6 rounded-2xl bg-amber-50 border border-amber-200 text-amber-900 text-sm px-5 py-4">
        This mobile number is already registered for the launch offer. Here are your saved details.
      </div>
    )}
    <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#FF7A00]">
      <PartyPopper className="w-4 h-4" /> Website Launch Offer
    </div>
    <h2 data-testid="launch-headline" className="mt-2 font-heading text-3xl md:text-4xl font-black text-[#0A192F] leading-tight">
      Congratulations, {r.name.split(" ")[0]}! You're eligible for <span className="bg-gradient-to-r from-[#FFB800] via-[#FF7A00] to-[#FF3D71] bg-clip-text text-transparent">50% OFF</span>
    </h2>
    <p data-testid="launch-message" className="mt-4 text-base text-[#334155] leading-relaxed">{LAUNCH_MESSAGE}</p>
    <div className="mt-3 inline-flex items-center gap-2 text-sm font-bold text-[#FF3D71]"><Flame className="w-4 h-4" /> Seats are filling up soon — first 100 students only</div>

    <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-3">
      <Stat label="Student" value={r.name} testId="launch-name" />
      <Stat label="Claim ID" value={r.claim_id} testId="launch-claim-id" accent="text-[#00B37E]" />
      <Stat label="Discount" value={`${r.discount}%`} testId="launch-discount" accent="text-[#FF7A00]" />
    </div>

    <div data-testid="launch-claim-instructions" className="mt-8 rounded-2xl bg-[#0A192F] text-white p-6">
      <div className="flex items-start gap-3">
        <Camera className="w-5 h-5 text-[#7CF0BD] mt-0.5 flex-shrink-0" />
        <p className="text-sm leading-relaxed">
          To claim this discount, take a screenshot and visit us at: <b className="text-white">{CENTRE_ADDRESS}</b>. Call: <a href={`tel:+91${CENTRE_PHONE}`} className="text-[#7CF0BD] font-bold">{CENTRE_PHONE}</a>.
        </p>
      </div>
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-xs text-white/70">
        <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#7CF0BD]" /> Sangam Vihar, New Delhi 110080</span>
        <span className="inline-flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-[#7CF0BD]" /> {BRAND.phone}</span>
      </div>
    </div>

    <div className="mt-6 flex flex-col sm:flex-row gap-3">
      <a href={WA_LINK(waMessage(r))} target="_blank" rel="noopener noreferrer" data-testid="launch-whatsapp-btn">
        <Button type="button" className="w-full sm:w-auto bg-[#25D366] hover:bg-[#1DA851] text-white font-semibold rounded-full h-12 px-7">
          <MessageCircle className="w-5 h-5 mr-2" /> Confirm Seat on WhatsApp
        </Button>
      </a>
      <a href={`tel:+91${CENTRE_PHONE}`} data-testid="launch-call-btn">
        <Button type="button" variant="outline" className="w-full sm:w-auto border-2 border-[#0A192F] text-[#0A192F] hover:bg-[#0A192F] hover:text-white font-semibold rounded-full h-12 px-7">
          <Phone className="w-4 h-4 mr-2" /> Call {CENTRE_PHONE}
        </Button>
      </a>
    </div>
  </div>
);
